$('.owl-carousel').owlCarousel({
  autoplay: true,
  autoplayTimeout: 4000,
  autoplayHoverPause: true,
  loop: true,
  margin: 30,
  responsiveClass: true,
  nav: true,
  loop: true,
  stagePadding: 0,
  responsive: {
    0: {
      items: 1
    },
    568: {
      items: 2
    },
    600: {
      items: 4
    },
    1000: {
      items: 4
    }
  }
})
